import {handleActions} from 'redux-actions';
import {APP_SET_COMPUTING, APP_SET_CONFIG} from './actions';

/**
 * App state
 */
export const appState = {
  computing: false,
  config: {}
};


/**
 * App reducer
 */
export default handleActions({
    [APP_SET_COMPUTING]: (state, action) => ({
      ...state,
      computing: action.payload
    }),
    [APP_SET_CONFIG]: (state, action) => ({
      ...state,
      config: action.payload
    }),
  },
  appState);
